import React from 'react'
import { useApiListAnalytic } from '../../../../../api-new/state/analytics'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { TableAgClient } from '../../../../../shared/table-builder/table-ag-client'
import { ColumnMenu, ColumnText } from '../../../../../shared/table-builder/table-columns'
import { Menu, MenuPurge, MenuRestore } from '../../../../../shared/menu/menu'
import { useRouteMatch } from 'react-router-dom'
import { useParamsInt } from '../../../../../shared/hooks/location'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { IconList } from '../../../../../shared/icon/icon'
import { recycleErrorMessage } from '../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../shared/error/use-error-line'

export const AnalyticCourseAnalyticRecycle = () => {
  const { url } = useRouteMatch()
  const { nodeID } = useParamsInt()

  const apiListAnalytic = useApiListAnalytic()

  const [error, failure, setError] = useErrorLine()

  const handleReady = () => apiListAnalytic.get(`${nodeID}/node/deleted`)
  const handleDestroyed = () => apiListAnalytic.init()

  const handleRestore = async data => {
    setError(null)
    try {
      await apiListAnalytic.put(`${data.id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That analytic was already removed.'), err)
    }
    await apiListAnalytic.get(`${nodeID}/node/deleted`)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Recycle">
        <CardFullHeightScrollY title="Recycle Bin">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListAnalytic} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="name" />
            <ColumnText field="description" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row)} show />
                  <MenuPurge to={`${url}/${row.id}/purge`} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
